module.exports = __webpack_public_path__ + "static/media/Y-Ship-Cloud-Getting-Started-Amazon.0770a042.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/Y-Ship-Cloud-Getting-Started-Amazon.pdf
// module id = 814
// module chunks = 0